import { render, staticRenderFns } from "./CreateMaterialGroup.vue?vue&type=template&id=21ea8744&scoped=true&"
import script from "./CreateMaterialGroup.vue?vue&type=script&lang=js&"
export * from "./CreateMaterialGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea8744",
  null
  
)

export default component.exports